var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-7" }, [
        false
          ? _c("div", [
              !_vm.useAutoList
                ? _c(
                    "div",
                    [
                      _vm._v("\n            Выберите препарат\n            "),
                      _c("ajaxDrugSearch", {
                        ref: "ajaxSearch",
                        attrs: { selectedDrug: _vm.selectDrug },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.useAutoList,
                      expression: "useAutoList",
                    },
                  ],
                  attrs: { id: "check_2", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.useAutoList)
                      ? _vm._i(_vm.useAutoList, null) > -1
                      : _vm.useAutoList,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.useAutoList,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.useAutoList = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.useAutoList = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.useAutoList = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "check_2" } }, [
                  _vm._v("На основе автосписка"),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "select_radio" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterList,
                  expression: "filterList",
                },
              ],
              attrs: { type: "radio", id: "r_2", name: "r_1", value: "2" },
              domProps: { checked: _vm._q(_vm.filterList, "2") },
              on: {
                change: function ($event) {
                  _vm.filterList = "2"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "r_2" } }, [
              _vm._v("Для построения автосписка"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterList,
                  expression: "filterList",
                },
              ],
              attrs: { type: "radio", id: "r_3", name: "r_3", value: "3" },
              domProps: { checked: _vm._q(_vm.filterList, "3") },
              on: {
                change: function ($event) {
                  _vm.filterList = "3"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "r_3" } }, [_vm._v("Вся бронь")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterList,
                  expression: "filterList",
                },
              ],
              attrs: { type: "radio", id: "r_4", name: "r_4", value: "5" },
              domProps: { checked: _vm._q(_vm.filterList, "5") },
              on: {
                change: function ($event) {
                  _vm.filterList = "5"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "r_4" } }, [
              _vm._v("На основе накладных"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterList,
                  expression: "filterList",
                },
              ],
              attrs: { type: "radio", id: "r_5", name: "r_5", value: "6" },
              domProps: { checked: _vm._q(_vm.filterList, "6") },
              on: {
                change: function ($event) {
                  _vm.filterList = "6"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "r_5" } }, [
              _vm._v("Проблемные заявки"),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.filterList == 6
          ? _c("div", { staticClass: "subRadio" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subFilter.conflict,
                      expression: "subFilter.conflict",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "r_1_1",
                    name: "r_1_1",
                    value: "1",
                  },
                  domProps: { checked: _vm._q(_vm.subFilter.conflict, "1") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.subFilter, "conflict", "1")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "pointer", attrs: { for: "r_1_1" } },
                  [_vm._v("не назначенные вовремя старшим курьером")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.subFilter.notAppointedByChiefOrders,
                        expression: "subFilter.notAppointedByChiefOrders",
                      },
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      disabled: !(_vm.subFilter.conflict == 1),
                      type: "checkbox",
                      id: "gridCheck5",
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.subFilter.notAppointedByChiefOrders
                      )
                        ? _vm._i(
                            _vm.subFilter.notAppointedByChiefOrders,
                            null
                          ) > -1
                        : _vm.subFilter.notAppointedByChiefOrders,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.subFilter.notAppointedByChiefOrders,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.subFilter,
                                "notAppointedByChiefOrders",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.subFilter,
                                "notAppointedByChiefOrders",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.subFilter,
                            "notAppointedByChiefOrders",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "gridCheck5" },
                    },
                    [
                      _vm._v(
                        "\n                в том числе заявки на завтра\n              "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subFilter.conflict,
                      expression: "subFilter.conflict",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: "r_1_2",
                    name: "r_1_2",
                    value: "2",
                  },
                  domProps: { checked: _vm._q(_vm.subFilter.conflict, "2") },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.subFilter, "conflict", "2")
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "pointer", attrs: { for: "r_1_2" } },
                  [
                    _vm._v(
                      "не согласованные и с отсутствующим свободным товаром на эти заявки"
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.cities
          ? _c("div", [
              _vm._v("\n          Выберите город\n          "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedCity,
                      expression: "selectedCity",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedCity = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.cityUpdated,
                    ],
                  },
                },
                [
                  _vm._l(_vm.citiesForSelect, function (city, index) {
                    return _vm.$currentRole === "admin" ||
                      (_vm.$currentRole !== "admin" &&
                        !_vm.citiesForAdminOnly.includes(city.id))
                      ? _c("option", { domProps: { value: city.id } }, [
                          _vm._v(_vm._s(city.title)),
                        ])
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "11+12" } }, [
                    _vm._v("Курск + Белгород"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "1+0" } }, [
                    _vm._v("Москва + Почта"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "0" } }, [_vm._v("Почта")]),
                  _vm._v(" "),
                  _vm.filterList == 6
                    ? _c("option", { attrs: { value: "-1" } }, [
                        _vm._v("Все города"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5" }, [
        _vm.filterList == 5
          ? _c("div", [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Введите ID накладных через запятую"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedInvoices,
                      expression: "selectedInvoices",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "5555,7777" },
                  domProps: { value: _vm.selectedInvoices },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.selectedInvoices = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selected_drugs" },
          _vm._l(
            _vm.sortedRecords(_vm.selectedDrugs),
            function (drug, id, index) {
              return _c(
                "div",
                { staticClass: "btn-group", attrs: { role: "group" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-sm title",
                      attrs: { type: "button" },
                    },
                    [_vm._v(_vm._s(drug.title) + " | " + _vm._s(drug.id))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeSelectedDrug(drug.id)
                        },
                      },
                    },
                    [_vm._v("-")]
                  ),
                ]
              )
            }
          ),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }